import React from 'react';
import Container from '@mui/material/Container';
import { Box, CircularProgress } from '@mui/material';
import NavBar from './NavBar';

function Loading() {
  
  return (
    <Box>
      <NavBar/>
      <Container sx={{margin: "auto"}}>
        <CircularProgress />
      </Container>
    </Box>
  );
}

export default Loading;
